/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

// open link and avoid potential vulnerability (https://www.jitbit.com/alexblog/256-targetblank---the-most-underestimated-vulnerability-ever/)
export const openInNewTab = (url: string) => {
  const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
  if (newWindow) newWindow.opener = null;
};
